export const State7 = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="12" height="12" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 7.25C2.25 5.16667 3.5 3.29167 6 1C8.5 3.29167 9.75 5.16667 9.75 7.25C9.75 9.32108 8.07107 11 6 11C3.92893 11 2.25 9.32108 2.25 7.25ZM8.877 6.66922C7.81122 6.26767 6.65658 6.80173 5.57463 7.30216C4.69392 7.70952 3.86137 8.09458 3.16412 7.93461C3.11131 7.71503 3.08333 7.48578 3.08333 7.25C3.08333 5.67669 3.93905 4.14329 6 2.14464C7.80697 3.89699 8.6875 5.2917 8.877 6.66922Z"
      fill="#CE2C31"
      stroke="#CE2C31"
      strokeWidth="0.3125"
    />
  </svg>
);
